window.angular.module('MyHippoProducer').config(function ($stateProvider, $urlRouterProvider) {
    // Default Route
    $urlRouterProvider.otherwise('/home');

    $stateProvider.state('home', {
        url: '/home',
        templateUrl: 'views/home.html',
        controller: 'HomeController',

        resolve: {
            // redirect homepage to React App producer url
            redirect: function ($window, $q, $location) {
                const reactProducerDomain = window.REACT_PRODUCER_DOMAIN;
                const protocol = $location.protocol();
                // handle angular url redirection
                // ex: https://danielmainorg.producer.staging.myhippo.io/#/leads/65f9361e-ce03-4734-a648-d55a7fdd04f3
                const hash = window.location.hash;
                $window.location.href = hash && !hash.includes('home') ?
                    `${protocol}://${reactProducerDomain}/login/${hash}` : `${protocol}://${reactProducerDomain}/login`;
                return $q.reject({error: 'Invalid login url'});
            }
        }
    });

    $stateProvider.state('forgotPassword', {
        url: '/forgot-password',
        templateUrl: 'views/forgot-password.html',
        controller: 'ForgotPasswordController',
        resolve: {
            redirect: function ($window, $q, $location) {
                const reactProducerDomain = window.REACT_PRODUCER_DOMAIN;
                const protocol = $location.protocol();

                $window.location.href = `${protocol}://${reactProducerDomain}/forget-password`;
                return $q.reject({error: 'Invalid login url'});
            }
        }
    });

    $stateProvider.state({
        name: 'portal',
        abstract: true,
        data: {requiresLogin: true},
        templateUrl: 'views/portal.html',
        controller: 'PortalController',
        resolve: { user: APIService => APIService.findCurrentUser() }
    });

    $stateProvider.state('portal.policyCreate', {
        url: '/policies/create',
        templateUrl: 'views/policies/policy.create.html',
        controller: 'PolicyCreateController',
        controllerAs: 'createCtrl',
        resolve: {
            clientAppUrl: function () {
                return "";
            },
            redirect: function ($window, $location, $mdDialog, APIService) {
                const protocol = $location.protocol();
                const reactProducerDomain = window.REACT_PRODUCER_DOMAIN;
                const subdomain = $window.location.host.split('.')[0];
                const params = $location.search();
                const reactAppUrl = `${protocol}://${subdomain}.${reactProducerDomain}/quote-flow/address`;

                if (!params.org) {
                    return APIService.findAvailableOrganizationsForUser().then((organizations) => {
                        const availableOrganizationsToCreateFrom = organizations.filter(o => o.is_producer && o.disable_policy_creation !== true);
                        if (availableOrganizationsToCreateFrom.length > 1) { // Producers have at least 1 org (main org)
                            return $mdDialog.show({
                                template: `<mh-select-policy-creation-modal choices="orgChoices"></mh-select-policy-creation-modal>`,
                                controller: function ($scope) { $scope.orgChoices = availableOrganizationsToCreateFrom; }
                            });
                        } else {
                            return;
                        }
                    }).then((dialogData) => {
                        if (dialogData && dialogData.id) {
                            $window.location.href = `${reactAppUrl}?orgId=${dialogData.id}`;
                        } else {
                            $window.location.href = $window.location.href.split('#')[0] + '#/policies';
                        }
                    });
                } else {
                    $window.location.href = `${reactAppUrl}?orgId=${params.org}`;
                }
            }
        }
    });

    $stateProvider.state('portal.policyDetails', {
        url: '/policies/:id/:pageKey?',
        params: {
            pageKey: 'policy_information_page'
        },
        templateUrl: 'views/policies/policy.details.html',
        controller: 'PolicyDetailsController',
        resolve: {
            'policyData': function ($stateParams, APIService) {
                return APIService.findPolicyById($stateParams.id, $stateParams.updateId);
            }
        }
    });
    // V2
    $urlRouterProvider.when('/policies2/:id/', '/policies2/:id/view/policy_information');
    $urlRouterProvider.when('/policies2/:id/view', '/policies2/:id/view/policy_information');
    $stateProvider.state('portal.policyDetailsV2', {
        url: '/policies2/:id/:mode/:page',
        templateUrl: 'pages/policy-details/policy-details.html',
        controller: 'PolicyDetailsV2Controller',
        params: {
            page: 'policy_information',
            mode: 'view',
        },
        resolve: {
            'policyData': function ($stateParams, PolicyService, $log) {
                const { id, mode } = $stateParams;

                const currentPolicyId = PolicyService.id;
                const currentMode = PolicyService.isEditMode ? 'edit' : 'view';
                if (currentPolicyId != id || currentMode !== mode) {
                    $log.info(`Fetching policy ${id}`);
                    return PolicyService.fetch(id, mode === 'edit', true);
                }
            }
        }
    });

    $stateProvider.state('portal.licenseError', {
        url: '/policies2/:id/license-errors',
        templateUrl: 'pages/errors/license-error/license-error.html',
        params: {
            error: '',
        },
    });

    $stateProvider.state('portal.leadDetails', {
        url: '/leads/:id?pageId',
        params: {pageId: ''},
        templateUrl: 'views/leads/lead.details.html',
        controller: 'LeadDetailsController',
        resolve: {
            redirect: function ($window, $stateParams, APIService, ReactRedirectService) {
                return APIService.findLeadUrl($stateParams.id, $stateParams.pageId)
                    .then((leadUrl) => {
                        return ReactRedirectService.redirectToQuoteFlow(leadUrl);
                    })
                    .catch((error) => {
                        console.error('Error when redirecting to React App', error);
                        $window.location.href = $window.location.href.split('#')[0] + '#/leads';
                    });
            }
        },
    });
});
